import { render, staticRenderFns } from "./voice-search-container.vue?vue&type=template&id=675bd5ba&"
import script from "./voice-search-container.vue?vue&type=script&lang=js&"
export * from "./voice-search-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports